/* Your Special Body: native controls, no framework required. */
import { StandardEvents } from '@shopify/events';
(() => {
  'use strict';
  if (window.ysbThemeLoaded) return;
  window.ysbThemeLoaded = true;

  function activateTab(root, value, focus = false) {
    root.querySelectorAll('[data-ysb-tab]').forEach(tab => {
      const active = tab.dataset.ysbTab === value;
      tab.setAttribute('aria-selected', String(active));
      tab.setAttribute('tabindex', active ? '0' : '-1');
      tab.dataset.state = active ? 'active' : 'inactive';
      if (active && focus) tab.focus();
    });
    root.querySelectorAll('[data-ysb-panel]').forEach(panel => {
      const active = panel.dataset.ysbPanel === value;
      panel.hidden = !active;
      panel.dataset.state = active ? 'active' : 'inactive';
    });
    if (root.dataset.ysbTabs === 'payment') {
      root.closest('.price-card')?.querySelectorAll('[data-ysb-payment-cta]').forEach(link => {
        link.hidden = link.dataset.ysbPaymentCta !== value;
      });
    }
  }

  let heroOutside = false;
  let heroObserver;
  let headerObserver;
  function updateMobileAction() {
    const action = document.querySelector('.ysb-experience .mobile-action');
    if (!action) return;
    const menuOpen = document.querySelector('[data-ysb-menu][aria-expanded="true"]');
    const visible = heroOutside && !menuOpen && window.matchMedia('(max-width: 760px)').matches;
    action.classList.toggle('is-visible', visible);
    action.toggleAttribute('inert', !visible);
  }

  function setMenu(open, returnFocus = false) {
    const toggle = document.querySelector('[data-ysb-menu]');
    const menu = document.getElementById('ysb-mobile-navigation');
    if (!toggle || !menu) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (returnFocus) toggle.focus();
    updateMobileAction();
  }

  function init() {
    document.querySelectorAll('[data-ysb-tabs]').forEach(root => {
      const selected = root.querySelector('[data-ysb-tab][aria-selected="true"]') || root.querySelector('[data-ysb-tab]');
      if (selected) activateTab(root, selected.dataset.ysbTab);
    });
    heroObserver?.disconnect();
    const hero = document.querySelector('.ysb-experience .hero');
    heroOutside = false;
    if (hero && 'IntersectionObserver' in window) {
      heroObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        heroOutside = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        updateMobileAction();
      });
      heroObserver.observe(hero);
    }
    headerObserver?.disconnect();
    const header = document.getElementById('header-group');
    if (header) {
      const measure = () => {
        const height = `${header.getBoundingClientRect().height}px`;
        document.body.style.setProperty('--header-height', height);
        document.body.style.setProperty('--header-group-height', height);
      };
      measure();
      if ('ResizeObserver' in window) {
        headerObserver = new ResizeObserver(measure);
        headerObserver.observe(header);
      }
    }
    updateMobileAction();
  }

  document.addEventListener('click', event => {
    const element = event.target instanceof Element ? event.target : null;
    if (!element) return;
    const tab = element.closest('[data-ysb-tab]');
    if (tab) {
      const root = tab.closest('[data-ysb-tabs]');
      if (root) activateTab(root, tab.dataset.ysbTab);
    }
    const menuToggle = element.closest('[data-ysb-menu]');
    if (menuToggle) setMenu(menuToggle.getAttribute('aria-expanded') !== 'true');
    else if (element.closest('#ysb-mobile-navigation a')) setMenu(false);
    else if (!element.closest('.ysb-experience .site-header')) setMenu(false);
  });

  document.addEventListener('keydown', event => {
    const tab = event.target instanceof Element ? event.target.closest('[data-ysb-tab]') : null;
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      const root = tab.closest('[data-ysb-tabs]');
      const tabs = [...root.querySelectorAll('[data-ysb-tab]')];
      let index = tabs.indexOf(tab);
      if (event.key === 'ArrowLeft') index = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'ArrowRight') index = (index + 1) % tabs.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = tabs.length - 1;
      event.preventDefault();
      activateTab(root, tabs[index].dataset.ysbTab, true);
    }
    if (event.key === 'Escape' && document.querySelector('[data-ysb-menu][aria-expanded="true"]')) setMenu(false, true);
  });

  document.addEventListener('change', event => {
    if (event.target instanceof Element && event.target.matches('.ysb-localization select')) {
      const form = event.target.closest('form');
      if (form?.requestSubmit) form.requestSubmit();
    }
  });
  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    event.promise?.then(({ cart, detail }) => {
      const count = cart?.totalQuantity ?? detail?.itemCount;
      if (typeof count === 'number') {
        document.querySelectorAll('[data-ysb-cart-count]').forEach(element => {
          element.textContent = String(count);
        });
      }
    }).catch(() => { /* Keep the previous count if the cart update fails. */ });
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => window.requestAnimationFrame(init));
  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 991px)').matches) setMenu(false);
    updateMobileAction();
  }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
